import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';
import { Subscription } from '@app/store/transport-layer/subscription/subscription';

export type PauseSubscriptionResponse = Subscription;
export function pauseSubscriptionAPI(workspaceId: string) {
  return requestApi<PauseSubscriptionResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription/unsubscribe`),
    method: 'POST',
    credentials: true,
  }).then((response) => response.data);
}
